import { render, staticRenderFns } from "./projectOverviewCompile.vue?vue&type=template&id=3d61c328&scoped=true&"
import script from "./projectOverviewCompile.vue?vue&type=script&lang=js&"
export * from "./projectOverviewCompile.vue?vue&type=script&lang=js&"
import style0 from "./projectOverviewCompile.vue?vue&type=style&index=0&id=3d61c328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61c328",
  null
  
)

export default component.exports